export default __webpack_public_path__ + "static/media/15.0610d8d8.mp3";